import { render, staticRenderFns } from "./ediGuideWindow.vue?vue&type=template&id=6bca0db0&"
import script from "./ediGuideWindow.vue?vue&type=script&lang=js&"
export * from "./ediGuideWindow.vue?vue&type=script&lang=js&"
import style0 from "./ediGuideWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bca0db0')) {
      api.createRecord('6bca0db0', component.options)
    } else {
      api.reload('6bca0db0', component.options)
    }
    module.hot.accept("./ediGuideWindow.vue?vue&type=template&id=6bca0db0&", function () {
      api.rerender('6bca0db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/leadPage/ediGuideWindow.vue"
export default component.exports